<template>
  <h3 class="text-sm text-dark-pewter-50 mb-6 whitespace-nowrap">
    <slot />
  </h3>
</template>
